module.exports = __webpack_public_path__ + "img/payment_failed.de4b3f76.png";